import TextArea from 'antd/lib/input/TextArea';
import { useState, TextareaHTMLAttributes } from 'react';
import getFormatMessage from '../../../../locales/get-format-message';
import { FullscreenOutlined } from '@ant-design/icons';
import styles from './index.module.scss';
import { ModalWrap } from '../../../component/modal-wrap';

export const CodeEditor = (
  props: TextareaHTMLAttributes<HTMLTextAreaElement>
) => {
  const [codeFullScreen, setCodeFullScreen] = useState<boolean>(false);

  if (codeFullScreen) {
    return (
      <ModalWrap
        title={getFormatMessage('cost_script')}
        width={`${innerWidth}px`}
        onClose={() => setCodeFullScreen(false)}
      >
        <TextArea
          {...props}
          placeholder={getFormatMessage('please_enter_cost_script')}
          autoSize={{ minRows: 10 }}
        />
      </ModalWrap>
    );
  }
  return (
    <div>
      <TextArea
        {...props}
        placeholder={getFormatMessage('please_enter_cost_script')}
        autoSize={{ minRows: 5, maxRows: 10 }}
      />
      <div
        className={styles.toggleFullScreen}
        onClick={() => setCodeFullScreen(!codeFullScreen)}
      >
        {<FullscreenOutlined />}
      </div>
    </div>
  );
};
